module.exports = {"top3":["Children without all recommended vaccines","Adults without a dental visit","Elderly patients who received a high-risk prescription drug"],"bottom3":["Adults with inappropriate lower back imaging","Hospital 30-day readmission rate ages 18-64","Employer-sponsored insurance spending per enrollee"],"most_improved":["Home health patients without improved mobility","High out-of-pocket medical spending","Breast cancer deaths"],"most_declined":["Hospital 30-day mortality","Children without a medical home","Preventable hospitalizations ages 18-64"]}


//////////////////
// WEBPACK FOOTER
// ./src/data/highlights/WI.json
// module id = 288
// module chunks = 143196823979170 184088790168614